/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import ACVideoPlayer from 'academy-common-lib/components/video/ACVideoPlayer';
import { ExternalLinkIcon } from 'foundations-assets';
import { Box } from 'foundations-components/transitional/components/Box';
import { Button } from 'foundations-components/transitional/components/Button';
import { Grid } from 'foundations-components/transitional/components/Grid';
import { GridItem } from 'foundations-components/transitional/components/Grid';
import { H1 } from 'foundations-components/transitional/components/H1';
import { Link } from 'foundations-components/transitional/components/Link';
import { Small } from 'foundations-components/transitional/components/Small';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { INTERNAL_PORTAL_ID } from '../../features/accounts';
// @ts-expect-error Could not find a declaration file for module
import { setUserGuideSettingsAndReturnUrl } from '../../actions/GettingStartedActions';
// @ts-expect-error Could not find a declaration file for module
import { getAccountsProductsByPortal } from '../../selectors/accountsSelectors';
import { onboardingSettingsExperienceMap, onboardingSettingsHubMap } from '../../constants/GettingStatedConsts';
import { getPricingPageUrl } from '../../utils/RoutingUtils';
import { getHighestHubPlan } from '../../utils/pricingUtils';
import UsageTracker from '../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const hubVideoId = {
  marketing: 177500911933,
  //fileManager: https://app.hubspot.com/files/137828/?folderId=177500740439&showDetails=177496906786
  sales: 172561433613,
  //fileManager: https://app.hubspot.com/files/137828/?folderId=172551291399&showDetails=172551291403
  service: 177499917629 //fileManager: https://app.hubspot.com/files/137828/?folderId=177496907045&showDetails=177500740639
};
const ModalVideoSection = ({
  hub,
  onCTAClick
}) => {
  var _hubVideoId$hub;
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  const dispatch = useDispatch();
  const portalId = useSelector(state => {
    var _state$auth;
    return state === null || state === void 0 || (_state$auth = state.auth) === null || _state$auth === void 0 || (_state$auth = _state$auth.portal) === null || _state$auth === void 0 ? void 0 : _state$auth.portal_id;
  });
  const ownedProducts = useSelector(getAccountsProductsByPortal);
  return /*#__PURE__*/_jsx(View, {
    as: "section",
    padding: isMobile ? '400' : '1000',
    children: /*#__PURE__*/_jsxs(Grid, {
      children: [/*#__PURE__*/_jsxs(GridItem, {
        marginBlockEnd: isMobile || isTablet ? '300' : '0',
        size: {
          md: 8,
          xs: 12
        },
        children: [/*#__PURE__*/_jsx(View, {
          borderRadius: "100",
          overflow: "hidden",
          children: /*#__PURE__*/_jsx(ACVideoPlayer, {
            creatorHubId: INTERNAL_PORTAL_ID,
            onFinish: () => {
              UsageTracker.track('interaction', {
                action: 'academy-to-software-modal-video-finished',
                hub,
                ownedPlan: getHighestHubPlan(ownedProducts, hub)
              });
            },
            onPlay: () => {
              UsageTracker.track('interaction', {
                action: 'academy-to-software-modal-video-played',
                hub,
                ownedPlan: getHighestHubPlan(ownedProducts, hub)
              });
            },
            videoId: (_hubVideoId$hub = hubVideoId[hub]) === null || _hubVideoId$hub === void 0 ? void 0 : _hubVideoId$hub.toString()
          })
        }), /*#__PURE__*/_jsx(Small, {
          marginBlockStart: "200",
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.softwareDesirability.modal.videoSection.helpText"
          })
        })]
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          md: 4
        },
        textAlign: "left",
        children: /*#__PURE__*/_jsxs(TFlex, {
          align: "stretch",
          blockSize: "100%",
          direction: "column",
          justify: "between",
          children: [/*#__PURE__*/_jsxs(Box, {
            marginBlockEnd: isTablet || isMobile ? '300' : '0',
            children: [/*#__PURE__*/_jsx(H1, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `learningCenter.softwareDesirability.modal.hubs.${hub}.videoSection.heading`
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: `learningCenter.softwareDesirability.modal.hubs.${hub}.videoSection.subheading`
            })]
          }), /*#__PURE__*/_jsx(Box, {
            children: /*#__PURE__*/_jsxs(TFlex, {
              align: "center",
              direction: "column",
              children: [/*#__PURE__*/_jsxs(Button, {
                block: true,
                "data-test-id": "academy-to-software-desirability-modal-video-section-user-guide-button",
                onClick: () => {
                  UsageTracker.track('interaction', {
                    action: 'academy-to-software-modal-user-guide-click',
                    hub,
                    ownedPlan: getHighestHubPlan(ownedProducts, hub),
                    section: 'video'
                  });
                  dispatch(setUserGuideSettingsAndReturnUrl(onboardingSettingsHubMap[hub.toUpperCase()], onboardingSettingsExperienceMap.NO_EXPERIENCE)).then(redirectUrl => {
                    onCTAClick();
                    window.open(redirectUrl, '_blank');
                  });
                },
                paddingBlock: "400",
                use: "primary",
                children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
                  message: `learningCenter.softwareDesirability.modal.${getHighestHubPlan(ownedProducts, hub) === 'free' ? 'primaryCTA' : 'primaryCTAPaid'}`,
                  options: {
                    hubName: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: `learningCenter.softwareDesirability.modal.hubs.${hub}.name`
                    })
                  }
                }), /*#__PURE__*/_jsx(ExternalLinkIcon, {
                  size: "300"
                })]
              }), /*#__PURE__*/_jsx(Link, {
                blockSize: "52px",
                "data-test-id": "academy-to-software-desirability-modal-video-section-features-button",
                external: true,
                href: getPricingPageUrl(portalId, hub),
                marginBlockStart: "300",
                onClick: () => {
                  UsageTracker.track('interaction', {
                    action: 'academy-to-software-modal-features-pricing-click',
                    hub,
                    ownedPlan: getHighestHubPlan(ownedProducts, hub),
                    section: 'video'
                  });
                  onCTAClick();
                },
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.softwareDesirability.modal.secondaryCTA"
                })
              })]
            })
          })]
        })
      })]
    })
  });
};
export default ModalVideoSection;